import {LoadingButton} from '@mui/lab';
import {Box} from '@mui/material';
import dayjs from 'dayjs';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../../api/axios';
import {apiBaseUrl} from '../../../api/urls';
import {AMSEModuleCalibrationHistoryQuery} from '../../../interfaces/AMSEModuleCalibrationHistory';
import {ExportField} from '../../../interfaces/Export';
import {saveFile} from '../../../utils/file';
import {CloseSnackbarAction} from '../../common/CloseSnackbarButton';
import ExportFieldForm from '../../common/ExportFieldForm';
import ModalFixed from '../../common/ModalFixed';
import SnackbarMessages from '../../common/SnackbarMessages';

interface Props {
  emoduleId?: number;
  params?: AMSEModuleCalibrationHistoryQuery;
  exportFields?: ExportField[];
}

const AMSEModuleCalibrationHistoryExportExcel = ({
  emoduleId,
  params,
  exportFields,
}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isFetching, setIsFetching] = useState(false);
  const [isOpened, setIsOpened] = useState(false);

  const fetchData = async (fields: string[]) => {
    setIsOpened(false);
    setIsFetching(true);

    try {
      const reqParams = {
        export: 'excel',
        fields,
        date_start: params?.date_start,
        date_end: params?.date_end,
        order: params?.order,
        dir: params?.dir,
      };

      const resp = await API.get(
        `${apiBaseUrl}/ams/emodule/${emoduleId}/calibration-history`,
        {
          params: reqParams,
          responseType: 'blob',
        }
      );
      const dateStart = params?.date_start ?? dayjs().format('YYYY-MM-DD');
      const dateEnd = params?.date_end ?? dayjs().format('YYYY-MM-DD');
      saveFile(resp.data, `calibration_history_${dateStart}_${dateEnd}.xlsx`);
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, 'STRA_e1c2a3l4');
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }
    setIsFetching(false);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" justifyContent="end">
        <LoadingButton
          fullWidth
          size="large"
          variant="contained"
          loading={isFetching}
          onClick={() => setIsOpened(true)}
        >
          Export to Excel
        </LoadingButton>
      </Box>
      <ModalFixed open={isOpened} onClose={() => setIsOpened(false)}>
        <Box
          display="flex"
          flexDirection="column"
          position="relative"
          gap={3}
          p={3}
        >
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center" width="100%" gap={1.5}>
              <ExportFieldForm
                exportFields={exportFields ?? []}
                onChange={fetchData}
                close={() => setIsOpened(false)}
                loading={isFetching}
                columns={3}
              ></ExportFieldForm>
            </Box>
          </Box>
        </Box>
      </ModalFixed>
    </Box>
  );
};

export default AMSEModuleCalibrationHistoryExportExcel;
